import React from 'react';

import config from '../../config';
import {type RouteData} from '../types';
import {
  ORG_ALERTS,
  ORG_API_KEYS,
  ORG_BILLING,
  ORG_DASHBOARD,
  ORG_SERVICE_ACCOUNTS,
  ORG_SETTINGS,
  ORG_SETTINGS_PATHS,
  ORG_TEAMS,
  ORG_USER_ACTIVITY,
} from './orgPaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

export const ORG_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via ORG_NESTED_ROUTES
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: [
      ORG_DASHBOARD,
      ORG_TEAMS,
      ORG_SERVICE_ACCOUNTS,
      ORG_API_KEYS,
      ORG_USER_ACTIVITY,
      ORG_BILLING,
      ORG_ALERTS,
    ],
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    path: '/org/roles',
    redirect: ORG_SETTINGS,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via ORG_NESTED_ROUTES
    },
    condition: IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ORG_SETTINGS_PATHS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
];
